import {useSelector, useDispatch} from 'react-redux'
import {SET_DATA_MODAL_FORM_LIST} from '../../../../../../store/modal/const'

const useShowUploadFileModal = () => {
  const dispatch = useDispatch()
  const reduxData = useSelector(
    (state) => state.modal.counseling.uploadFileModal,
  )
  const {isOpen, onChange, task} = reduxData

  const setOpen = (open, onChange = () => {}, task = {}) => {
    dispatch({
      type: SET_DATA_MODAL_FORM_LIST,
      payload: 'counseling.uploadFileModal',
      data: {
        ...reduxData,
        isOpen: open,
        task: task,
        onChange,
      },
    })
  }

  const setTaskData = (task) => {
    dispatch({
      type: SET_DATA_MODAL_FORM_LIST,
      payload: 'counseling.uploadFileModal',
      data: {
        ...reduxData,
        task,
      },
    })
  }

  return {
    isOpen,
    onChange,
    open: (onChange = () => {}, task = {}) => {
        setOpen(true, onChange, task)
      },
    close: () => {
      setOpen(false)
    },
    toggle: () => {
      setOpen(!isOpen)
    },
    task,
    setTaskData,
  }
}
export default useShowUploadFileModal
